import rutasGenericas from "../../config/apiBase";

export default rutasGenericas({ modelo: "seguimiento" });
